document.addEventListener('DOMContentLoaded', function() {
    // Hide default yeps bar
    const style = document.createElement( 'style' )
    style.setAttribute('type','text/css')
    style.innerHTML = `[id^='yeps-'] { opacity: 0; height: 0; width: 0; visibility:hidden;}`;
    if(document.getElementById('yeps')) {
      const shadow = document.getElementById('yeps').shadowRoot
      shadow.appendChild( style )
    }
})
